export default __webpack_public_path__ + "static/media/star1.661a21e6.mp3";